// What to tell the user when the App Store or Google Play could not start a subscription.
export type PurchaseFeedback = "purchasesRestricted" | "appStore" | "googlePlay" | "generic";

/** Feedback for the error store.order() resolved with, or undefined when there is nothing to tell. */
export function purchaseFeedbackForOrderError(error:any):PurchaseFeedback|undefined {
  if (!error || error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
    return undefined;
  }

  if (error.platform === CdvPurchase.Platform.APPLE_APPSTORE) {
    // Mostly Apple Account or payment method problems, which StoreKit reports as an unknown error.
    return "appStore";
  }

  // The message is the response code, followed by Google's debug message in patched plugin builds.
  if (error.platform === CdvPurchase.Platform.GOOGLE_PLAY && String(error.message).startsWith("BILLING_UNAVAILABLE")) {
    // Google Play answers BILLING_UNAVAILABLE for an outdated Play Store, an unsupported country,
    // purchases blocked by an admin, or a payment method it cannot charge.
    return "googlePlay";
  }

  return "generic";
}



// WEBPACK FOOTER //
// ./src/components/subscription/purchaseFeedback.ts